
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`FAQ`}</h1>
    <h3>{`Where can I find tutorial materials?`}</h3>
    <p>{`Tutorial materials can be found `}<a href='/tutorial'>{`on our tutorial page`}</a>{`.`}</p>
    <br />
    <h3>{`How much does OpenABA cost?`}</h3>
    <p>{`OpenABA is free, and it is our desire to keep it that way for as long as possible.`}</p>
    <br />
    <h3>{`How can I help?`}</h3>
    <p>{`We are always in need of more help, especially amidst the COVID pandemic. If you are interested in getting involved, learn more `}<a href="/volunteer">{`on our volunteer page`}</a>{`.`}</p>
    <br />
    <h3>{`Do you support school-based ABA?`}</h3>
    <p>{`Yes! We understand additional coordination is often required in school-based ABA.`}</p>
    <br />
    <h3>{`Can OpenABA be used by parents?`}</h3>
    <p>{`Yes; this is a way of using OpenABA we've seen growing in popularity. Reach out at `}<a parentName="p" {...{
        "href": "mailto:team@openaba.com"
      }}>{`team@openaba.com`}</a>{` if you need help setting up. `}</p>
    <p>{`We are also in the process of developing features to better allow BCBAs to train and enable parents to make progress towards learning goals, and are always looking for input and help in designing those features. If you can help us brainstorm what a killer tool for this would look like, please get in touch at `}<a parentName="p" {...{
        "href": "mailto:team@openaba.com"
      }}>{`team@openaba.com`}</a>{`.`}</p>
    <br />
    <h3>{`Can OpenABA be used in in-person direct services?`}</h3>
    <p>{`Yes; while we are prioritizing use in remote care during the COVID pandemic, many of our users have reported success in using OpenABA in in-person sessions. If you would like to get a quick demo on best practices and tips, contact us at `}<a parentName="p" {...{
        "href": "mailto:team@openaba.com"
      }}>{`team@openaba.com`}</a>{`.`}</p>
    <br />
    <h3>{`Does OpenABA provide supervision tools?`}</h3>
    <p>{`We do not currently provide supervision tools, though we are currently considering adding it to our `}<a href='/release'>{`feature release schedule`}</a>{`. If you would like to see supervision tools added to OpenABA, let us know at `}<a parentName="p" {...{
        "href": "mailto:features@openaba.com"
      }}>{`features@openaba.com`}</a>{`.`}</p>
    <br />
    <h3>{`Is OpenABA available in my country?`}</h3>
    <p>{`OpenABA currently serves users in the following countries.`}</p>
    <ul>
      <li parentName="ul">{`United States`}</li>
      <li parentName="ul">{`Canada`}</li>
      <li parentName="ul">{`Australia`}</li>
      <li parentName="ul">{`New Zealand`}</li>
      <li parentName="ul">{`India`}</li>
      <li parentName="ul">{`Mexico`}</li>
      <li parentName="ul">{`Philippines`}</li>
      <li parentName="ul">{`Singapore`}</li>
      <li parentName="ul">{`United Kingdom`}</li>
      <li parentName="ul">{`Ireland`}</li>
      <li parentName="ul">{`United Arab Emirates`}</li>
      <li parentName="ul">{`Saudi Arabia`}</li>
      <li parentName="ul">{`Qatar`}</li>
      <li parentName="ul">{`Bahrain`}</li>
      <li parentName="ul">{`Indonesia`}</li>
      <li parentName="ul">{`France`}</li>
      <li parentName="ul">{`South Africa`}</li>
      <li parentName="ul">{`Romania`}</li>
    </ul>
    <p>{`If your country is not listed above, please contact us at `}<a parentName="p" {...{
        "href": "mailto:team@openaba.com."
      }}>{`team@openaba.com.`}</a>{` We are typically able to fulfill international access requests within 24 hours.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;